// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.942Z

export type PutAuthCurrentPasswordApiResponse = unknown;
export type PutAuthCurrentPasswordApiArg = {
    /** Invalidate other sessions */
    "logout-all"?: boolean;
    formDataAuthPutCurrentPasswordRequest: FormDataAuthPutCurrentPasswordRequest;
};
export type PostAuthOauthSignInApiResponse =
  /** status 200 OK */ AuthPostOAuthSignInResponse;
export type PostAuthOauthSignInApiArg = {
    "oauth-provider-name"?: string;
    "oauth-email"?: string;
    "oauth-provider-token"?: string;
    authPostOAuthSignInRequest: AuthPostOAuthSignInRequest;
};
export type GetAuthOauthByProviderAndModeApiResponse =
  /** status 200 OK */ AuthGetOAuthOutputResponse;
export type GetAuthOauthByProviderAndModeApiArg = {
    "query_no-redirect"?: "yes" | "no" | "once";
    code?: string;
    state?: string;
    error?: string;
    host?: string;
    /** Login return URL */
    "ret-url"?: null | string;
    provider: string;
    mode: "authorize" | "verify";
    "cookie_no-redirect"?: "yes" | "no" | "-";
    "request-id"?: AuthRequestId;
};
export type GetAuthSessionApiResponse =
  /** status 200 OK */ AuthGetSessionsResponse;
export type GetAuthSessionApiArg = void;
export type DeleteAuthSessionApiResponse = unknown;
export type DeleteAuthSessionApiArg = void;
export type DeleteAuthSessionBySessionIdApiResponse = unknown;
export type DeleteAuthSessionBySessionIdApiArg =
  /** Active Session ID. */ string;
export type PostAuthSignInApiResponse =
  /** status 200 OK */ AuthPostSignInResponse;
export type PostAuthSignInApiArg = AuthPostSignInRequest;
export type DeleteAuthSignOutApiResponse =
  /** status 200 OK */ AuthDeleteSignOutResponse;
export type DeleteAuthSignOutApiArg = {
    /** Invalidate other sessions */
    "logout-all"?: boolean;
    /** Login return URL */
    "ret-url"?: null | string;
};
export type PostAuthSignUpApiResponse =
  /** status 200 OK */ AuthPostSignUpResponse;
export type PostAuthSignUpApiArg = {
    "X-Recaptcha-Token": string;
    authPostSignUpRequest: AuthPostSignUpRequest;
};
export type GetAuthSignUpDataApiResponse =
  /** status 200 OK */ AuthGetSignUpDataResponse;
export type GetAuthSignUpDataApiArg = void;
export type PostAuthVerifyApiResponse =
  /** status 200 OK */ AuthPostVerifyResponse;
export type PostAuthVerifyApiArg = {
    "X-Recaptcha-Token": string;
    authPostVerifyRequest: AuthPostVerifyRequest;
};
export type PutAuthByUserIdPasswordApiResponse = unknown;
export type PutAuthByUserIdPasswordApiArg = {
    /** Invalidate other sessions */
    "logout-all"?: boolean;
    /** User ID. */
    "user-id": number;
    formDataAuthPutUserPasswordRequest: FormDataAuthPutUserPasswordRequest;
};
export type RouterUnauthorizedError = {
    /** Application-specific error code. */
    code?: number;
    /** Application context. */
    context?: {
        [key: string]: any;
    };
    /** Error message. */
    error?: string;
    /** Status text. */
    status?: string;
};
export type AuthPassword = string;
export type FormDataAuthPutCurrentPasswordRequest = {
    "new-password": AuthPassword;
    "old-password": AuthPassword;
};
export type AuthPostOAuthSignInCheckAuthResult = {
    message?: string;
    ok?: boolean;
};
export type AuthJwtToken = {
    expire?: string;
    token?: string;
};
export type AuthOAuthProviderToken = {
    /** OAuth provider name */
    provider: string;
    /** Token */
    token: string;
};
export type AuthPostOAuthSignInResponse = {
    "api-token"?: string;
    "check-auth-result"?: AuthPostOAuthSignInCheckAuthResult;
    "current-user"?: null | string;
    email?: string;
    "jwt-token"?: AuthJwtToken;
    "oauth-provider-tokens"?: AuthOAuthProviderToken[];
    "ret-url"?: null | string;
    status?: UsercommonStatus;
    "user-id"?: number;
};
export type AuthPostOAuthSignInRequest = {
    "check-auth"?: boolean;
    /** Currently logged in user email */
    "current-user"?: null | string;
    email?: string;
    /** Invalidate other sessions */
    "logout-other"?: boolean;
    /** Expire JWT token in 2 weeks if true and in 3 hours if false */
    "long-term-token"?: boolean;
    /** Token for connected OAuth account */
    "oauth-provider-token"?: AuthOAuthProviderToken;
    /** Login return URL */
    "ret-url"?: null | string;
};
export type AuthRequestId = string | "-";
export type AuthGetOAuthOutputResponse = {
    location?: string;
    "request-id"?: AuthRequestId;
};
export type AuthSession = {
    created?: string;
    expire?: string;
    id: string;
    "remote-ip"?: string;
    "ua-type"?: string;
    "user-agent"?: string;
};
export type AuthGetSessionsResponse = {
    sessions?: AuthSession[];
};
export type AuthPostSignInResponse = {
    "api-token"?: string;
    "current-user"?: null | string;
    email?: string;
    "jwt-token"?: AuthJwtToken;
    "oauth-provider-tokens"?: AuthOAuthProviderToken[];
    "ret-url"?: null | string;
    status?: UsercommonStatus;
    "user-id"?: number;
};
export type AuthPostSignInRequest = {
    /** Currently logged in user email */
    "current-user"?: null | string;
    email: string;
    /** Invalidate other sessions */
    "logout-other"?: boolean;
    /** Expire JWT token in 2 weeks if true and in 3 hours if false */
    "long-term-token"?: boolean;
    password?: string;
    /** Login return URL */
    "ret-url"?: null | string;
};
export type AuthDeleteSignOutResponse = {
    "ret-url"?: null | string;
    success?: boolean;
};
export type AuthPostSignUpResponse = {
    created?: string;
    status?: UsercommonStatus;
    updated?: string;
    "user-id"?: number;
};
export type AuthPostSignUpRequest = {
    email: string;
    "first-name"?: null | string;
    "invite-id": string;
    "last-name"?: null | string;
    password: AuthPassword;
};
export type AuthGetSignUpDataResponse = {
    "oauth-providers"?: string[];
    "recaptcha-site-key"?: string;
};
export type AuthPostVerifyResponse = {
    email?: string;
    status?: UsercommonStatus;
    success?: boolean;
};
export type AuthPostVerifyRequest = {
    /** Signup Email Verification token. */
    "verify-token"?: string;
};
export type FormDataAuthPutUserPasswordRequest = {
    "new-password": AuthPassword;
    "old-password": AuthPassword;
};
export enum UsercommonStatus {
    Anonymous = "anonymous",
    Pending = "pending",
    Active = "active",
    Suspended = "suspended",
}
